<app-toast></app-toast>
@if (clientInitStatus() === 'not-found' || clientInitStatus() === 'error') {
  <app-not-config
    [statusCode]="clientInitCodeStatus()"
    [message]="getMessage(clientInitCodeStatus())"
  ></app-not-config>
} @else {
  @if (hasUpdate()) {
    <div class="pwa-update-banner" role="status" aria-live="polite">
      <span>Hay una nueva versión disponible.</span>
      <div class="pwa-update-banner__actions">
        <button type="button" class="pwa-update-banner__btn" (click)="dismissUpdate()">
          Más tarde
        </button>
        <button
          type="button"
          class="pwa-update-banner__btn pwa-update-banner__btn--primary"
          (click)="reloadForUpdate()"
        >
          Actualizar ahora
        </button>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
}
